<template>
  <div>
    <ElButton
      size="small"
      type="primary"
      :loading="loading"
      @click="openModal('publishRequestModal')"
    >
      {{ $t('APP.RELEASES.RESEND_PUBLISH_REQUEST') }}
    </ElButton>

    <PublishRequestModal
      v-model="publishRequestModal"
      :note.sync="developerNote"
      :file.sync="developerFile"
      :release="release"
      :app="app"
      @confirm="resendPublishRequest"
    />
  </div>
</template>

<script>
import PublishRequestModal from '@@/app/AppReleases/common/PublishRequestModal';
import { Release } from '@/api/api';
import modal from '@/mixins/modal';
import packageName from '@/mixins/packageName';
import { REPLACE_RELEASE, APP_DETAILS } from '@/store/types';
import { mapActions, mapGetters } from 'vuex';
import form from '@/mixins/form';
import ErrorsListModal from '@@/common/ErrorsListModal';

export default {
  name: 'ResendPublishRequestButton',
  components: { PublishRequestModal },
  mixins: [modal, packageName, form],
  props: {
    release: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      publishRequestModal: false,
      developerNote: '',
      developerFile: null,
      loading: false,
    };
  },

  computed: {
    ...mapGetters({ app: APP_DETAILS }),
  },

  methods: {
    ...mapActions({ replaceReleaseInStore: REPLACE_RELEASE }),
    resendPublishRequest() {
      this.loading = true;

      const params = {
        id: this.release.token,
        packageName: this.packageName,
        developerNote: this.developerNote,
        file: this.developerFile,
      };

      return Release.reviewRequest(params)
        .then(({ release, warnings }) => {
          this.replaceReleaseInStore(release);

          if (warnings?.length) {
            const warningsText = warnings.join('<br>');

            this.$alert(warningsText, this.$t('WARNING'), {
              type: 'warning',
              confirmButtonText: this.$t('GOT_IT'),
              showCancelButton: false,
              dangerouslyUseHTMLString: true,
            });
          }
        })
        .catch(({ message, errors }) => {
          if (errors?.length) {
            this.$modal.open({
              component: ErrorsListModal,
              title: this.$t('ERROR'),
              props: { message, errors },
              width: '30%',
            });
          } else {
            this.$message.error(message);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
